import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import ControlRow from "../utils/components/ControlRow";

import { searchModule } from "../utils/Utils";
import { setAlert } from "../../actions/alertActions";

import "../../styles/utils/_loadingScreen.scss";
import "../../styles/components/evs/OtherEVs.scss";
import signout from "../../styles/images/signout.svg";
import no_vehicles from "../../styles/images/no_vehicles.svg";

class OtherEVs extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      loading: true,
      search: "",
      fleets: [],
      selectedFleet: null,

      leaveGroup: false,
    };

    this.handleLeaveGroup = this.handleLeaveGroup.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchFleets();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchFleets() {
    axios
      .get("/api/private/fleets/otherEvs", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              loading: false,
              fleets: res.data,
            },
            () => {
              if (this.state.fleets.length > 0) {
                let idx = -1;
                if (this.state.selectedFleet)
                  idx = this.state.fleets.findIndex(
                    (f) => f._id === this.state.selectedFleet._id
                  );
                this.safeSetState({
                  selectedFleet:
                    idx !== -1 ? this.state.fleets[idx] : this.state.fleets[0],
                });
              }
            }
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleLeaveGroup(e) {
    let leaveDriver = [];
    let leaveGroup = [];
    this.state.selectedFleet.listEvs.forEach((ev) => {
      if (
        ev.listOfDrivers.findIndex((d) => d.userId === this.props.userId) !== -1
      )
        leaveDriver.push(ev.evId);
      ev.listOfGroupDrivers.forEach((group) => {
        if (
          group.hasOwnProperty("listOfDrivers") &&
          group.listOfDrivers.findIndex(
            (d) => d.userId === this.props.userId
          ) !== -1
        ) {
          leaveGroup.push(group.groupId);
        }
      });
    });

    leaveDriver.map((_id) =>
      axios
        .patch(
          "/api/private/evs/leaveBeDriver",
          { _id },
          { cancelToken: new CancelToken((c) => (this.cancel = c)) }
        )
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        )
    );

    leaveGroup.map((_id) =>
      axios
        .patch(
          "/api/private/groupDrivers/leaveGroupDrivers",
          { _id },
          { cancelToken: new CancelToken((c) => (this.cancel = c)) }
        )
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.message), "danger")
        )
    );

    this.safeSetState(
      {
        leaveGroup: false,
      },
      () => {
        this.props.setAlert(I18n.t("otherEvs_leaveGroupSuccess"), "primary");
        this.fetchFleets();
      }
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return !this.state.loading ? (
      <div id="otherEVs" className="main-container">
        <div className="control-bar">
          <ControlRow
            showSearch={this.state.fleets.length > 0}
            search={this.state.search}
            onSearchChange={(e) => searchModule.setSearch(this, e.target.value)}
            showCarousel={this.state.fleets.length > 0}
            carousel={{
              items: this.state.fleets,
              selected: this.state.selectedFleet
                ? this.state.fleets.findIndex(
                    (i) => i._id === this.state.selectedFleet._id
                  )
                : 0,
              onSelect: (selectedFleet) => this.safeSetState({ selectedFleet }),
            }}
            buttons={[
              {
                show: this.state.selectedFleet !== null,
                label: "otherEVs_leaveGroup",
                text: signout,
                onClick: () => this.safeSetState({ leaveGroup: true }),
              },
            ]}
          />
        </div>
        {this.state.fleets.length === 0 && (
          <div className="no-fleets">
            <img src={no_vehicles} alt="" />
            <p className="title">
              <Translate value="evs_noOtherEVsTitle" />
            </p>
            <p className="text">
              <Translate value="evs_noOtherEVsText" />
            </p>
          </div>
        )}
        {this.state.fleets.length > 0 && (
          <div className="component-container">
            <div className="table-container">
              <div className="table-header">
                <div className="row no-gutters">
                  <div className="col-12 row no-gutters titles">
                    <div className="col title">
                      <Translate value="evs_vehicles" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_plate" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_range" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_batteryCapacity" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_electricMotorPower" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_internalChargePower" />
                    </div>
                    <div className="col title">
                      <Translate value="evs_fastChargePower" />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.selectedFleet !== null && (
                <div className="table-values">
                  {this.state.selectedFleet.listEvs
                    .filter((i) => searchModule.filter(this, i))
                    .map((veh) => {
                      return (
                        <div key={veh.evId} className="row no-gutters">
                          <div className="col-12 row no-gutters values slim">
                            <div
                              className={"col"}
                            >{`${veh.brand} ${veh.model}`}</div>
                            <div className="col">{veh.licensePlate}</div>
                            <div className="col">
                              {veh.evInfo && veh.evInfo.range !== null
                                ? `${veh.evInfo.range}km`
                                : "-"}
                            </div>
                            <div className="col">
                              {veh.evInfo &&
                              veh.evInfo.maxBatteryCapacity !== null
                                ? `${veh.evInfo.maxBatteryCapacity}kWh`
                                : "-"}
                            </div>
                            <div className="col">
                              {veh.evInfo &&
                              veh.evInfo.eletricMotorPower !== null
                                ? `${veh.evInfo.eletricMotorPower}kW`
                                : "-"}
                            </div>
                            <div className="col">
                              {veh.evInfo &&
                              veh.evInfo.internalChargerPower !== null
                                ? `${veh.evInfo.internalChargerPower}kW`
                                : "-"}
                            </div>
                            <div className="col">
                              {veh.evInfo &&
                              veh.evInfo.maxFastChargingPower !== null
                                ? `${veh.evInfo.maxFastChargingPower}kW`
                                : "-"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        )}
        <div
          className={
            "notification " + (this.state.leaveGroup ? "show" : "hide")
          }
        >
          <div className="info">
            <p id="info-title">
              <Translate value="otherEVs_leaveGroup" />
            </p>
            <p id="info-desc">
              <Translate value="otherEVs_leaveGroupInfo" />
            </p>
          </div>
          <div className="buttons">
            <button
              type="button"
              className="secondary"
              onClick={this.handleLeaveGroup}
            >
              <Translate value="otherEVs_continueBtn" />
            </button>
            <button
              type="button"
              onClick={() => this.safeSetState({ leaveGroup: false })}
            >
              <Translate value="otherEVs_cancelBtn" />
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="generic-loading">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userId: state.account.accountData.id,
});

export default connect(mapStateToProps, { setAlert })(OtherEVs);
